import React, { useMemo } from 'react';
import {
    ConnectionProvider,
    WalletProvider,
$} from '@solana/wallet-adapter-react';
import { 
    PhantomWalletAdapter,
    MathWalletAdapter, SolongWalletAdapter,SolflareWalletAdapter } from '@solana/wallet-adapter-wallets'; // Phantom or Sollet (or others)
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { clusterApiUrl } from '@solana/web3.js';
// require("@solana/wallet-adapter-react-ui/styles.css");

const AppWalletProvider = ({ children }) => {
    const network = 'devnet'; // or 'testnet' or 'mainnet-beta'
    const endpoint = useMemo(() => clusterApiUrl(network), [network]);
    
    
    
    const RPC_ENDPOINT = "https://proportionate-warmhearted-putty.solana-mainnet.quiknode.pro/90d4729ba1c52e2aa7db328944713bcd4c408e67";
    const HELIUS_RPC = "https://mainnet.helius-rpc.com/?api-key=e7017d59-07ed-4ad7-955a-5b16d052233e"
    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(), // Phantom wallet adapter
            new SolflareWalletAdapter(), // Phantom wallet adapter
            new MathWalletAdapter(), // Phantom wallet adapter
            new SolongWalletAdapter(), // Phantom wallet adapter
            
        ],
        [network]
    );

    return (
        <ConnectionProvider endpoint={HELIUS_RPC}>
            <WalletProvider wallets={wallets} autoConnect>
            <WalletModalProvider>{children}</WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};

export default AppWalletProvider;
